import { useEffect } from "react";
import { Field, useForm } from "react-final-form";
import type { FieldValue, SimpleFieldValue } from "../../types";

type Props<T> = {
	when: string;
	is: T;
	children: React.ReactNode;
	fieldName?: string;
};

export const Condition = <T extends SimpleFieldValue = string>({
	when,
	is,
	children,
	fieldName,
}: Props<T>) => {
	const form = useForm();

	return (
		<Field<FieldValue> name={when} subscription={{ value: true }}>
			{({ input: { value } }) => {
				const isSubQuestionActive = value === is;
				// biome-ignore lint/correctness/useHookAtTopLevel: Not conditional
				useEffect(() => {
					if (!isSubQuestionActive && fieldName) {
						form.change(fieldName, undefined); // remove inactive question answers from form state
					}
				}, [JSON.stringify(value)]);

				if (isSubQuestionActive) return children;
				return null;
			}}
		</Field>
	);
};
